// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const APP_VERSION = {
    "dirty": false,
    "raw": "1c265d5",
    "hash": "1c265d5",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "1c265d5",
    "semverString": null,
    "name": "smhfs-nx-ml",
    "version": "0.0.8"
};
/* tslint:enable */
